import { isFunction } from 'lodash';
import { parseExperiments } from 'wix-rich-content-common/libs/experiments';
export function experimentStrategy(wixExperiments) {
    var features = {
        ricosFeatures: {},
        wixRicosFeatures: {},
    };
    if (!wixExperiments) {
        return features;
    }
    var unboxed = isFunction(wixExperiments === null || wixExperiments === void 0 ? void 0 : wixExperiments.all) ? wixExperiments.all() : wixExperiments;
    var experiments = parseExperiments(unboxed);
    return Object.entries(experiments).reduce(function (featureList, _a) {
        var name = _a[0], experiment = _a[1];
        if ((experiment === null || experiment === void 0 ? void 0 : experiment.namespace) === 'wixRicos') {
            featureList.wixRicosFeatures[name] = experiment;
        }
        else if ((experiment === null || experiment === void 0 ? void 0 : experiment.namespace) === 'ricos') {
            featureList.ricosFeatures[name] = experiment;
        }
        return featureList;
    }, features);
}
//# sourceMappingURL=experimentStrategy.js.map